import { Components, Theme } from '@mui/material/styles';
import { palette } from 'theme/palette.ts';
import { DEFAULT_BORDER_RADIUS } from 'theme/constants.ts';

const alertSuccessStyle = {
  color: palette.text.white,
  backgroundColor: palette.green['600'],
};

const alertErrorStyle = {
  color: palette.text.white,
  backgroundColor: palette.red['300'],
};

const alertInfoStyle = {
  color: palette.text.white,
  backgroundColor: palette.grey['600'],
};

export const MuiAlert: Components<Theme>['MuiAlert'] = {
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      const { severity } = ownerState;
      let colorStyle = {};
      if (severity === 'success') {
        colorStyle = alertSuccessStyle;
      } else if (severity === 'error') {
        colorStyle = alertErrorStyle;
      } else if (severity === 'info') {
        colorStyle = alertInfoStyle;
      } else if (severity === 'warning') {
        colorStyle = {
          color: palette.text.primary,
          backgroundColor: theme.palette.warning.main,
          border: `1px solid ${theme.palette.amber[200]}`,
        };
      }

      return {
        borderRadius: DEFAULT_BORDER_RADIUS,
        paddingTop: theme.spacing(7),
        paddingBottom: theme.spacing(7),
        ...colorStyle,
      };
    },
    icon: ({ ownerState, theme }) => {
      const { severity } = ownerState;
      if (severity === 'warning') {
        return {
          padding: 0,
          color: `${theme.palette.amber[200]} !important`,
          lineHeight: 1,
          fontSize: theme.typography.pxToRem(24),
          alignItems: 'center',
        };
      }

      return {};
    },
    message: ({ theme }) => ({
      ...theme.typography.text1,
      padding: 0,
      lineHeight: theme.typography.pxToRem(24),
    }),
  },
};
